import {
  Resource_AppointmentTaskContentType,
  Resource_AppointmentTaskStatus,
} from '@/generated/graphql';
import { CheckCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import { AppointmentTaskComponent } from '@components/appointment-details/appointment-tasks/types';
import { AveliosButton } from '@components/common-layout/avelios-button';
import { Error } from '@components/error';
import { Space } from 'antd';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { exportDocument } from '../../../../helpers/document/document-export';
import { proxy_buildDocumentDownloadUrl } from '../../../../helpers/document/document-url-helper';

export const DocumentDownloadTask: FC<AppointmentTaskComponent> = ({
  proxyAppointmentTask,
  updateAppointmentTaskStatus,
}) => {
  const { formatMessage } = useIntl();

  const appointmentTask = proxyAppointmentTask.appointmentTask;

  const done =
    appointmentTask?.status === Resource_AppointmentTaskStatus.AppointmentTaskStatusFinished;

  const clinicId = proxyAppointmentTask.clinicId;

  const staticDocumentGroupId = appointmentTask?.contentReferences?.find(
    (ref) =>
      ref?.type ===
      Resource_AppointmentTaskContentType.AppointmentTaskContentTypeStaticDocumentGroup,
  )?.referenceId;

  const documentDownloadUrl = useMemo(() => {
    if (clinicId && staticDocumentGroupId) {
      return proxy_buildDocumentDownloadUrl(clinicId, staticDocumentGroupId, true, true);
    }
    return undefined;
  }, [clinicId, staticDocumentGroupId]);

  const handleDownload = (documentUrl: URL | undefined) => {
    if (documentUrl) {
      exportDocument(documentUrl).then(() => {
        if (!done) {
          updateAppointmentTaskStatus(Resource_AppointmentTaskStatus.AppointmentTaskStatusFinished);
        }
      });
    }
  };

  return (
    <Space direction={'vertical'} style={{ width: '100%' }}>
      <p>{formatMessage({ id: 'appointment-task.document-download.description' })}</p>
      {!documentDownloadUrl ? (
        <Error />
      ) : (
        <AveliosButton
          block
          disabled={!documentDownloadUrl}
          onClick={() => handleDownload(documentDownloadUrl)}
          type={'primary'}
          icon={!done ? <DownloadOutlined /> : <CheckCircleOutlined />}
          style={done ? { backgroundColor: 'darkgreen', color: 'white' } : undefined}
        >
          {!done
            ? formatMessage({ id: 'appointment-task.document-download.download' })
            : formatMessage({ id: 'appointment-task.document-download.download-again' })}
        </AveliosButton>
      )}
    </Space>
  );
};
